// extracted by mini-css-extract-plugin
module.exports = {"container":"segment-details-module__container___C6_89","removeProject":"segment-details-module__removeProject___1LBIx"};